import { instance } from "@src/service/api";
import { AttributeGroup } from "../../actions/models/atributesGroups";

type ByProductResponse = {
  attribute_groups: AttributeGroup[];
};

export const attributesApi = {
  getAttributesFromIIKO(restaurant_id: string) {
    return instance.get(`/v3/restaurant/${restaurant_id}/attribute-groups`);
  },

  getAttributesFromIIKOByProduct(restaurantId: string, productId: string) {
    return instance
      .get<ByProductResponse>(
        `/v3/restaurant/${restaurantId}/attribute-groups/${productId}`
      )
      .then((res) => res.data.attribute_groups);
  },
};
